// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemIbptColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import financialService from 'services/financialService';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the IBPT (approximate tax burden) column for item subtables.
function itemIbptColumn(options = {}) {
  const { size, ..._ } = options;
  const fontSize = resolveItemFontSize(size, 10);
  return {
    title: 'IBPT',
    dataIndex: ['tax', 'ibptTotal'],
    width: 60,
    align: 'right',
    sorter: (a, b) => {
      const aVal = a?.tax?.ibptTotal || a?.ibptTotal || 0;
      const bVal = b?.tax?.ibptTotal || b?.ibptTotal || 0;
      return aVal - bVal;
    },
    render: (_, item) => {
      const ibpt = item?.tax?.ibptTotal || item?.ibptTotal;
      if (!ibpt) {
        return (
          <Text style={{ fontSize }} type="secondary">
            —
          </Text>
        );
      }
      return (
        <Text style={{ fontSize }} type="secondary">
          {financialService.formatCurrency(ibpt)}
        </Text>
      );
    },
  };
}

export default itemIbptColumn;
